import { Box, Container, Paper, Stack } from '@mui/material'
import { ReactNode } from 'react'
import defaultLogo from '../../assets/logo.png'
import { PLATFORM_BACKGROUND_URL, PLATFORM_LOGO_URL } from '../Signup/platformAssets'

// Full-bleed platform-branded shell (background + LogikSpark logo above a card), matching the /login and
// /signup pages. Used by the pre-app boot/error screens (e.g. PersonaGate's failed / noAccess states) so
// they aren't bare white cards. Platform assets only — no tenant-branding fetch: these are error/boot
// states where another network call would be fragile. The blob-hosted logo falls back ONCE to the bundled
// asset (a can't-404 backstop) so a dead URL never loops nor leaves the card logo-less (same guard as the
// /login page).
const PlatformBrandedShell = ({ children }: { children: ReactNode }) => (
  <Box
    sx={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      backgroundImage: `url(${PLATFORM_BACKGROUND_URL})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
    }}
  >
    <Container maxWidth='sm' sx={{ py: 8 }}>
      <Paper elevation={2} sx={{ p: 4 }}>
        <Stack spacing={3} alignItems='center'>
          <Box
            component='img'
            src={PLATFORM_LOGO_URL}
            alt='LogikSpark'
            onError={(e) => {
              const img = e.currentTarget as HTMLImageElement
              if (img.dataset.fallbackApplied) {
                return
              }
              img.dataset.fallbackApplied = 'true'
              img.src = defaultLogo
            }}
            sx={{ maxHeight: 64, maxWidth: '100%', objectFit: 'contain' }}
          />
          {children}
        </Stack>
      </Paper>
    </Container>
  </Box>
)

export default PlatformBrandedShell
